import React from 'react';
import MainContent from 'shared/components/common/MainContent';
import useTitleUpdate from 'shared/utils/hooks/useTitleUpdate';

const Employees: React.FC<{}> = () => {
    useTitleUpdate('Employees');
    return (
        <MainContent>
            <h1>Employees Info component works!</h1>
        </MainContent>
    );
};

export default Employees;
